import type { Map as MapboxMap } from 'mapbox-gl';

// Real Manchester council boundaries (approximate polygons based on actual boundaries)
const authorityZonesData: GeoJSON.FeatureCollection = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: {
        name: 'Manchester City Council',
        color: '#3b82f6',
        laneRental: '£2,500/day',
        permitSLA: '2 working days',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-2.28, 53.5],
            [-2.22, 53.5],
            [-2.19, 53.48],
            [-2.19, 53.46],
            [-2.22, 53.44],
            [-2.28, 53.44],
            [-2.3, 53.46],
            [-2.3, 53.48],
            [-2.28, 53.5],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Salford City Council',
        color: '#10b981',
        laneRental: '£0',
        permitSLA: '5 working days',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-2.3, 53.5],
            [-2.28, 53.5],
            [-2.3, 53.48],
            [-2.32, 53.48],
            [-2.34, 53.49],
            [-2.33, 53.5],
            [-2.3, 53.5],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Trafford Council',
        color: '#f59e0b',
        laneRental: '£1,200/day',
        permitSLA: '3 working days',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-2.3, 53.48],
            [-2.28, 53.44],
            [-2.3, 53.42],
            [-2.34, 53.42],
            [-2.36, 53.44],
            [-2.34, 53.47],
            [-2.32, 53.48],
            [-2.3, 53.48],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Tameside Council',
        color: '#8b5cf6',
        laneRental: '£800/day',
        permitSLA: '4 working days',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-2.19, 53.48],
            [-2.15, 53.49],
            [-2.12, 53.48],
            [-2.12, 53.45],
            [-2.15, 53.44],
            [-2.19, 53.46],
            [-2.19, 53.48],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Stockport Council',
        color: '#ef4444',
        laneRental: '£1,500/day',
        permitSLA: '3 working days',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-2.22, 53.44],
            [-2.19, 53.46],
            [-2.15, 53.44],
            [-2.15, 53.4],
            [-2.19, 53.39],
            [-2.22, 53.4],
            [-2.22, 53.44],
          ],
        ],
      },
    },
  ],
};

export function addZoneBoundaries(map: MapboxMap) {
  map.addSource('authority-zones', {
    type: 'geojson',
    data: authorityZonesData,
  });

  // Semi-transparent fill
  map.addLayer({
    id: 'authority-boundaries',
    type: 'fill',
    source: 'authority-zones',
    layout: { visibility: 'none' },
    paint: {
      'fill-color': ['get', 'color'],
      'fill-opacity': 0.08,
    },
  });

  // Boundary outlines with glow
  map.addLayer({
    id: 'authority-boundaries-outline',
    type: 'line',
    source: 'authority-zones',
    layout: { visibility: 'none' },
    paint: {
      'line-color': ['get', 'color'],
      'line-width': 2,
      'line-opacity': 0.6,
      'line-dasharray': [4, 3],
    },
  });

  // Authority labels
  map.addLayer({
    id: 'authority-labels',
    type: 'symbol',
    source: 'authority-zones',
    layout: {
      visibility: 'none',
      'text-field': ['get', 'name'],
      'text-size': 12,
      'text-font': ['DIN Pro Medium', 'Arial Unicode MS Regular'],
      'text-transform': 'uppercase',
      'text-letter-spacing': 0.1,
    },
    paint: {
      'text-color': ['get', 'color'],
      'text-opacity': 0.7,
      'text-halo-color': '#050a15',
      'text-halo-width': 2,
    },
  });
}
